/* =============================================
   new-collection.js
   Carousel Navigation + AJAX Add to Cart
   ============================================= */

(function () {
  'use strict';
  if (window.nfcScriptLoaded) return;
  window.nfcScriptLoaded = true;

  /* ─── Carousel ──────────────────────────────── */

  function initCarousels() {
    var grids = document.querySelectorAll(
      '.nfc-desktop-wrap[data-view="carousel"], .nfc-mobile-wrap[data-view="carousel"]'
    );

    grids.forEach(function (grid) {
      if (grid.dataset.nfcInit) return;
      grid.dataset.nfcInit = 'true';
      updateArrowVisibility(grid);
      grid.addEventListener('scroll', function () {
        updateArrowVisibility(grid);
      }, { passive: true });
    });

    document.querySelectorAll('.nfc-arrow').forEach(function (btn) {
      if (btn.dataset.nfcInit) return;
      btn.dataset.nfcInit = 'true';
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('data-target');
        var grid = document.getElementById(targetId);
        if (!grid) return;
        var card = grid.querySelector('.nfc-card');
        if (!card) return;
        var cardWidth = card.offsetWidth + parseInt(getComputedStyle(grid).gap || '16', 10);
        var colsAttr = parseInt(grid.getAttribute('data-cols') || '4', 10);
        var scrollAmount = cardWidth * colsAttr;
        if (btn.classList.contains('nfc-arrow--prev')) {
          grid.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        } else {
          grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      });
    });
  }

  function updateArrowVisibility(grid) {
    var id = grid.id;
    if (!id) return;
    var prevBtn = document.querySelector('.nfc-arrow--prev[data-target="' + id + '"]');
    var nextBtn = document.querySelector('.nfc-arrow--next[data-target="' + id + '"]');
    if (!prevBtn || !nextBtn) return;
    var scrollLeft = grid.scrollLeft;
    var maxScroll = grid.scrollWidth - grid.clientWidth;
    prevBtn.style.opacity = scrollLeft <= 4 ? '0' : '1';
    prevBtn.style.pointerEvents = scrollLeft <= 4 ? 'none' : 'auto';
    nextBtn.style.opacity = scrollLeft >= maxScroll - 4 ? '0' : '1';
    nextBtn.style.pointerEvents = scrollLeft >= maxScroll - 4 ? 'none' : 'auto';
  }

  /* ─── AJAX Add to Cart ──────────────────────── */

  function initATC() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-atc]');

      // ─── CRITICAL FIX ───────────────────────────────────────────────────
      // Only handle clicks that are STRICTLY on [data-atc] buttons.
      // Do NOT call stopPropagation() — it was killing Prestige's
      // x-header, cart-drawer, and shopify-account Web Components.
      // ────────────────────────────────────────────────────────────────────
      if (!btn) return;

      // Extra safety: ignore if the click originated from a header element
      if (e.target.closest('header, .header, x-header, cart-drawer, shopify-account')) return;

      e.preventDefault(); // prevent href navigation on the button only

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      if (btn.classList.contains('is-loading') || btn.classList.contains('is-success')) return;

      addToCart(btn, variantId);
    });
  }

  function addToCart(btn, variantId) {
    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error ' + res.status);
        return res.json();
      })
      .then(function (item) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');

        var textEl = btn.querySelector('.nfc-atc-btn__text');
        if (textEl) {
          var originalHTML = textEl.innerHTML;
          textEl.innerHTML = '✓ Added';
          setTimeout(function () {
            textEl.innerHTML = originalHTML;
            btn.classList.remove('is-success');
            btn.disabled = false;
          }, 2000);
        } else {
          setTimeout(function () {
            btn.classList.remove('is-success');
            btn.disabled = false;
          }, 2000);
        }

        refreshCartCount();

        document.dispatchEvent(new CustomEvent('nfc:cart:added', {
          detail: { item: item, variantId: variantId }
        }));

        openThemeCart();
      })
      .catch(function (err) {
        console.error('[NFC ATC]', err);
        btn.classList.remove('is-loading');
        btn.disabled = false;

        var textEl = btn.querySelector('.nfc-atc-btn__text');
        if (textEl) {
          var originalHTML = textEl.innerHTML;
          textEl.innerHTML = '⚠ Try again';
          setTimeout(function () {
            textEl.innerHTML = originalHTML;
          }, 2000);
        }
      });
  }

  function refreshCartCount() {
    // Prestige's <cart-count> and <cart-drawer> both listen for cart:refresh and re-read /cart.js
    // themselves, so this is all that's needed to update the header badge and the drawer contents.
    // The previous version wrote directly into selectors from other themes (.cart-count-bubble,
    // #CartCount, ...), none of which exist here, so the badge never moved until a page reload.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('nfc:cart:updated', {
          detail: { cart: cart }
        }));
      })
      .catch(function () {});
  }

  function openThemeCart() {
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;

    // Prestige's DialogElement exposes show(); `open` is a boolean attribute, not a method.
    if (typeof drawerEl.show === 'function') {
      drawerEl.show();
    } else {
      drawerEl.setAttribute('open', '');
    }
  }

  /* ─── Wishlist Toggle & Storage ─────────────── */

  function updateWishlistButtons() {
    var wishlist = JSON.parse(localStorage.getItem('theme:wishlist-handles') || '[]');
    document.querySelectorAll('.nfc-wishlist-btn, .cfc-wishlist-btn').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      if (wishlist.indexOf(handle) > -1) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  function initWishlist() {
    updateWishlistButtons();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.nfc-wishlist-btn, .cfc-wishlist-btn');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;

      var wishlist = JSON.parse(localStorage.getItem('theme:wishlist-handles') || '[]');
      var index = wishlist.indexOf(handle);

      if (index > -1) {
        wishlist.splice(index, 1);
        btn.classList.remove('is-active');
      } else {
        wishlist.push(handle);
        btn.classList.add('is-active');
      }

      localStorage.setItem('theme:wishlist-handles', JSON.stringify(wishlist));

      // Sync other buttons for the same product on the page
      document.querySelectorAll('.nfc-wishlist-btn[data-product-handle="' + handle + '"], .cfc-wishlist-btn[data-product-handle="' + handle + '"]').forEach(function (otherBtn) {
        if (index > -1) {
          otherBtn.classList.remove('is-active');
        } else {
          otherBtn.classList.add('is-active');
        }
      });

      document.dispatchEvent(new CustomEvent('theme:wishlist:updated', {
        detail: { wishlist: wishlist, handle: handle, active: index === -1 }
      }));

      // If we are on the wishlist page, refresh the layout immediately
      if (window.location.pathname.indexOf('/pages/wishlist') > -1) {
        renderWishlistPage();
      }
    });

    // Run dynamic wishlist page renderer
    renderWishlistPage();
  }

  function renderWishlistPage() {
    if (window.location.pathname.indexOf('/pages/wishlist') === -1) return;

    var container = document.querySelector('.main-page__content');
    if (!container) {
      var sectionStack = document.querySelector('.shopify-section--main-page .section-stack');
      if (sectionStack) {
        container = sectionStack.querySelector('.nfc-wishlist-wrapper');
        if (!container) {
          container = document.createElement('div');
          container.className = 'nfc-wishlist-wrapper main-page__content';
          sectionStack.appendChild(container);
        }
      }
    }
    if (!container) return;

    var handles = JSON.parse(localStorage.getItem('theme:wishlist-handles') || '[]');

    if (handles.length === 0) {
      container.innerHTML = `
        <div style="text-align: center; padding: 48px 20px;">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5" style="margin-bottom: 16px;">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
          <p style="font-size: 16px; color: #666; margin-bottom: 24px;">Your wishlist is currently empty.</p>
          <a href="/collections/all" class="nfc-viewall-btn" style="background: #50169c; color: #fff; border: none; border-radius: 40px; padding: 12px 30px; font-weight: 600; text-decoration: none; display: inline-flex; align-items: center; gap: 8px;">
            Continue Shopping
          </a>
        </div>
      `;
      return;
    }

    // Render skeleton loaders
    container.innerHTML = `
      <div class="nfc-desktop-wrap" data-cols="4" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 20px;">
        ${handles.map(function() {
          return `
            <div class="nfc-card nfc-card--placeholder">
              <div class="nfc-card__img-wrap nfc-ratio--square" style="aspect-ratio: 1/1; background: #eee;"></div>
              <div class="nfc-card__body" style="padding: 14px;">
                <div class="nfc-ph-line nfc-ph-line--lg" style="height: 15px; background: #e0e0e0; margin-bottom: 8px;"></div>
                <div class="nfc-ph-line" style="height: 12px; background: #e0e0e0; margin-bottom: 8px;"></div>
                <div class="nfc-ph-line nfc-ph-line--sm" style="height: 10px; background: #e0e0e0;"></div>
              </div>
            </div>
          `;
        }).join('')}
      </div>
    `;

    // Fetch product details
    var fetchPromises = handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('Error');
          return res.json();
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(fetchPromises).then(function (products) {
      var validProducts = products.filter(function (p) { return p !== null; });

      if (validProducts.length === 0) {
        container.innerHTML = `
          <div style="text-align: center; padding: 48px 20px;">
            <p style="font-size: 16px; color: #666; margin-bottom: 24px;">Your wishlist is currently empty.</p>
            <a href="/collections/all" class="nfc-viewall-btn" style="background: #50169c; color: #fff; border-radius: 40px; padding: 12px 30px; font-weight: 600; text-decoration: none;">Continue Shopping</a>
          </div>
        `;
        return;
      }

      container.innerHTML = `
        <div class="nfc-desktop-wrap" data-cols="4" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 20px;">
          ${validProducts.map(function (product) {
            var priceFormatted = '₹' + (product.price / 100).toFixed(0);
            var comparePriceHtml = '';
            if (product.compare_at_price > product.price) {
              comparePriceHtml = `<s class="nfc-compare-price" style="color: #999; margin-left: 8px;">₹${(product.compare_at_price / 100).toFixed(0)}</s>`;
            }

            var atcHtml = '';
            if (!product.available) {
              atcHtml = `
                <button class="nfc-atc-btn nfc-atc-btn--soldout" disabled type="button" style="border-radius: 8px; font-size: 13px; padding: 10px; border: 1.5px solid #e0e0e0;">
                  Sold Out
                </button>
              `;
            } else if (product.variants.length === 1) {
              atcHtml = `
                <button class="nfc-atc-btn" type="button" data-variant-id="${product.variants[0].id}" data-product-title="${product.title.replace(/"/g, '&quot;')}" data-atc style="border-radius: 8px; font-size: 13px; padding: 10px; border: 1.5px solid #222;">
                  Add to Cart
                </button>
              `;
            } else {
              atcHtml = `
                <a href="${product.url}" class="nfc-atc-btn nfc-atc-btn--select" style="border-radius: 8px; font-size: 13px; padding: 10px; border: 1.5px solid #222; text-align: center; display: block;">
                  Select Options
                </a>
              `;
            }

            return `
              <div class="nfc-card" data-product-id="${product.id}" style="position: relative;">
                <div class="nfc-card__img-wrap nfc-card__img-wrap--square" style="position: relative;">
                  <button class="nfc-wishlist-btn is-active" type="button" aria-label="Remove from wishlist" data-product-handle="${product.handle}" data-product-id="${product.id}" style="position: absolute; top: 10px; right: 10px; z-index: 3; display: flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 50%; background: rgba(255,255,255,0.92); border: none; cursor: pointer; color: #e02020;">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                    </svg>
                  </button>
                  <a href="${product.url}" class="nfc-card__img-link" style="display: block; aspect-ratio: 1/1;">
                    <img class="nfc-card__img" src="${product.featured_image}" alt="${product.title.replace(/"/g, '&quot;')}" style="width: 100%; height: 100%; object-fit: cover;">
                  </a>
                </div>
                <div class="nfc-card__body" style="padding: 14px; display: flex; flex-direction: column; gap: 6px;">
                  <div class="nfc-vendor" style="font-size: 10px; color: #999; text-transform: uppercase;">${product.vendor}</div>
                  <a href="${product.url}" class="nfc-card__title-link" style="text-decoration: none; color: inherit;">
                    <h3 class="nfc-card__title" style="font-size: 14px; margin: 0; font-weight: 600;">${product.title}</h3>
                  </a>
                  <div class="nfc-price-wrap" style="display: flex; align-items: center; gap: 8px;">
                    <span class="nfc-price" style="font-weight: 700;">${priceFormatted}</span>
                    ${comparePriceHtml}
                  </div>
                  <div class="nfc-atc-form" style="margin-top: 4px;">
                    ${atcHtml}
                  </div>
                </div>
              </div>
            `;
          }).join('')}
        </div>
      `;
    });
  }

  /* ─── Init ──────────────────────────────────── */

  function init() {
    initCarousels();
    initATC();
    initWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init carousels on Shopify Theme Editor section load
  document.addEventListener('shopify:section:load', function () {
    initCarousels();
  });

})();